module.exports = __webpack_public_path__ + "static/media/black-hat.c5951d23.glb";